import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spring, animated } from 'react-spring';

import { formatCurrency } from 'js/services/Format';
import Title from 'js/components/core/SteppedPage/Title';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';

import Constraint from './Constraint';
import Backdrop from './Backdrop';
import SubTitle from './SubTitle';
import Container from './Container';
import StepMessage from './StepMessage';
import Label from './Label';
import Value from './Value';
import Row from './Row';
import { Amount, Money } from './BottomRow';
import analytics from "js/services/Analytics";
import { url } from 'js/services/Network';
import UserCountry from 'js/services/UserCountry';

@inject('page')
@observer
export default class Token extends Component {

  onAccepted(){
    const purchaseToken = this.purchase_token;

    analytics.track('Funds Accepted and Item Shipped', {
      'Payment Confirmation': '#' + purchaseToken.alias.toUpperCase(),
      'Method': purchaseToken.payment_method,
      'From': '@' + purchaseToken.buyer,
      'For': purchaseToken.title,
      'Shipping': 'covered by buyer',
      'Amount': formatCurrency(purchaseToken.price, UserCountry() === 'NG' ? 'NGN' : 'USD'),
      'Event Initiated by': 'buyer'
    });
    this.nextStep();
  }

  componentDidMount(){
    const page = this.props.page;
    analytics.track('Offer Link Visited', {
      'Item Price': page.purchase_token.price,
      'Item Name': page.purchase_token.title,
      'Item Size': page.size,
      'Payment Link': url('token-page', { 'alias': page.alias }),
      'Event Initiated by': 'buyer'
    });
  }

  render() {
    const page = this.props.page;
    const purchaseToken = page.purchase_token;
    return (
      <>
        <Backdrop>
          <Constraint>
            <Title>@{purchaseToken.buyer}</Title>
            <SubTitle>is ready to buy your item!</SubTitle>

            <Spring
              native
              from={{ opacity: 0, top: '10px', position: 'relative' }}
              to={{ opacity: 1, top: '0px' }}
              config={{ delay: 200 }}>
              {animation => (
                <animated.div style={animation}>
                  <Container>
                    <Row>
                      <Label>PREPAY CONFIRMATION</Label>
                      <Value>#{purchaseToken.alias.toUpperCase()}</Value>
                    </Row>
                    <Row>
                      <Label>METHOD</Label>
                      <Value>{purchaseToken.payment_method}</Value>
                    </Row>
                    <Row>
                      <Label>FROM</Label>
                      <Value>@{purchaseToken.buyer}</Value>
                    </Row>
                    <Row>
                      <Label>FOR</Label>
                      <Value>{purchaseToken.title}</Value>
                    </Row>
                    <Row>
                      <Label>SHIPPING</Label>
                      <Value>covered by buyer</Value>
                    </Row>
                    <Row>
                      <Amount>AMOUNT</Amount>
                      <Money>{formatCurrency(purchaseToken.price)}</Money>
                    </Row>
                  </Container>
                  <ContinueButton flat autoFocus onClick={this.onAccepted.bind(this.props.page)}>
                    Accept funds and Ship item
                  </ContinueButton>
                </animated.div>
              )}
            </Spring>
          </Constraint>
        </Backdrop>

        <StepMessage>
          Funds will be secured to your account immediately and unlocked when the item is delivered.
        </StepMessage>
      </>
    );
  }
}
